import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { createAccountYield } from 'store/actions/account-yields/createAccountYields';
import AccountYieldsCreateForm from './AccountYieldsCreateForm';

class AccountYieldsCreateContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            history,
            dispatchForm,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                callback: (error) => {
                    if (error) {
                        // This location should have where we bounce the error back to the form with SubmissionError.
                        resolve();
                    }

                    resolve(history.push('/account_yields'));
                },
                values: values,
            });
        });
    }

    render() {
        const {
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.account_yields.title'),
                link: '/account_yields',
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.account_yields.actions.create') } />

                    <Actions>
                        <ListButton url='/account_yields' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <AccountYieldsCreateForm
                            form='campaigns_create'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

AccountYieldsCreateContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createAccountYield(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(AccountYieldsCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/account-yields/create/AccountYieldsCreateContainer.js